import { render, staticRenderFns } from "./SearchInstancesList.vue?vue&type=template&id=08ff5706"
import script from "./SearchInstancesList.vue?vue&type=script&lang=js"
export * from "./SearchInstancesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports